import * as Styles from './styles';
import toTestId from '../../testUtils/toTestId';

interface Props {
  name: string;
  iconText: string;
  iconColor: string;
}

interface WorkflowProps {
  name: string;
}

function WorkflowPreviewCard({
  name,
}: WorkflowProps) {
  return (
    <>
      <Styles.PreviewCard
        data-testid={`card-${toTestId(name)}`}
      >
        <div>
          <Styles.CardHeader>
            <Styles.CardTitle>
              {name}
                <Styles.WarningMessage>
                  <Styles.WarningIcon />Access is restricted from this location
                </Styles.WarningMessage>
            </Styles.CardTitle>
          </Styles.CardHeader>
        </div>
      </Styles.PreviewCard>
    </>
  );
}

function ApplicationPreviewCard({
  name,
  iconText,
  iconColor,
}: Props) {
  return (
    <>
      <Styles.PreviewCard
        data-testid={`card-${toTestId(name)}`}
      >
        <div>
          <Styles.CardHeader>
              <Styles.ProductIcon iconColor={iconColor} data-testid="app-icon">
                {iconText || ''}
              </Styles.ProductIcon>
            <Styles.CardTitle>
              {name}
                <Styles.WarningMessage>
                  <Styles.WarningIcon />Access is restricted from this location
                </Styles.WarningMessage>
            </Styles.CardTitle>
          </Styles.CardHeader>
        </div>
      </Styles.PreviewCard>
    </>
  );
}

export { ApplicationPreviewCard, WorkflowPreviewCard}

